import {
  Label,
  InputGroup,
  Input,
  InputGroupLabel,
  Message,
  Description,
} from '@sbab-ui/components'
import { NumericFormat } from 'react-number-format'

interface Props {
  value: number
  label: string
  suffix?: string
  id: 'startAmount' | 'savedEachMonth' | 'savingTimeInYears' | 'placementAmount'
  inputChangeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void
  errorMessage?: string
  isValidHandler?: (value: number) => boolean
  maxLength: number
  wide?: boolean
  description?: string
}

export default function CustomInput({
  value,
  label,
  suffix,
  id,
  inputChangeHandler,
  errorMessage,
  isValidHandler,
  maxLength,
  wide,
  description,
}: Readonly<Props>) {
  let hasError = false
  if (isValidHandler !== undefined) {
    hasError = !isValidHandler(value)
  }
  return (
    <div className={`mb-6 flex flex-col ${wide ? '' : 'sm:mr-3 sm:max-w-[13.6rem]'}`}>
      <Label block className="mb-1" htmlFor={id}>
        {label}
      </Label>
      {description ? (
        <>
          <Description id="description">{description}</Description>
          <div className="h-2" />
        </>
      ) : null}
      <InputGroup data-cs-mask block>
        <NumericFormat
          value={value}
          customInput={Input}
          id={id}
          data-label={id}
          aria-describedby={description ? 'description' : null}
          thousandSeparator=" "
          onChange={inputChangeHandler}
          maxLength={maxLength}
          invalid={hasError}
          style={{ width: '100%' }}
        />
        {suffix && <InputGroupLabel>{suffix}</InputGroupLabel>}
      </InputGroup>
      {hasError ? (
        <Message
          tone="critical"
          className={`mt-1  ${wide ? '' : 'sm:max-w-[13.6rem]'}`}
          data-cy="input-error-msg"
        >
          {errorMessage}
        </Message>
      ) : null}
    </div>
  )
}
